import request from 'superagent/lib/client';
import config from '../config.json';

export default {

  // Log user in
  login: (username, password) => {
    return new Promise((resolve, reject) => {
      request.post(`${config.apiUrl}/login/auth`)
        .send({
          username,
          password
        })
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

    // Initiate forgot password process
    forgotPassword: (username) => {
      return new Promise((resolve, reject) => {
        request.post(`${config.apiUrl}/forgotpassword`)
          .send({
            username,
          })
          .end((err, response) => {
            if (err) {
              reject(err);
            }
            try {
              const res = JSON.parse(response.text);
              resolve(res);
            } catch (e) {
              resolve('');
            }
          });
      });
    },

    // Confirm forgot password process
    newPassword: (username, code, newPassword) => {
      return new Promise((resolve, reject) => {
        request.post(`${config.apiUrl}/forgotpassword/confirm`)
          .send({
            username,
            code,
            newPassword,
          })
          .end((err, response) => {
            if (err) {
              reject(err);
            }
            try {
              const res = JSON.parse(response.text);
              resolve(res);
            } catch (e) {
              resolve('');
            }
          });
      });
    },
    
  


  // Get token
  getToken: (code) => {
    return new Promise((resolve, reject) => {
      request.post(`${config.apiUrl}/oauth2/token`)
        .send({
          code
        })
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get ratings list for place
  getInfos: (hash) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/basic/${hash}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },


  // Get ratings list for place
  getRatings: (hash) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/place/${hash}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },


  // Get average for 3 categories for place
  getAvg3: (hash) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/place/getAvg3/${hash}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get average for 3 categories for user
  getUserAvg3: () => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/getAvg3`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get ratings history
  getRatingsHistory: (hash, start, end) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/place/history/${hash}/${start}/${end}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get ratings history for user
  getUserRatingsHistory: (start, end) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/history/${start}/${end}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },


  // Get detailed average ratings history
  getAverageHistory: (hash, start, end) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/place/history/average/${hash}/${start}/${end}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get detailed average ratings history for user
  getUserAverageHistory: (start, end) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/history/average/${start}/${end}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get emails history for user
  getUserEmailsHistory: (start, end) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/emails/history/${start}/${end}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get emails count
  getUserEmails: () => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/emails`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

    // Get reviews metrics
    getMetricsFirstLast: (hash) => {
      return new Promise((resolve, reject) => {
        request.get(`${config.apiUrl}/user/metrics/place/${hash}`)
          .set('Access-token', localStorage.getItem('token'))
          .end((err, response) => {
            if (err) {
              reject(err);
            }
            try {
              const res = JSON.parse(response.text);
              resolve(res);
            } catch (e) {
              resolve('');
            }
          });
      });
    },
  



  // Get list etablissements
  getEtablissements: () => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/items`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get list bills
  getBills: () => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/bills`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get CSV with emails and ratings
  getCSV: (hash) => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user/ratings/download/${hash}`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Get user infos
  getUserInfo: () => {
    return new Promise((resolve, reject) => {
      request.get(`${config.apiUrl}/user`)
        .set('Access-token', localStorage.getItem('token'))
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },

  // Update user password
  updatePassword: (oldPassword, password) => {
    return new Promise((resolve, reject) => {
      request.post(`${config.apiUrl}/user/password`)
        .set('Access-token', localStorage.getItem('token'))
        .send({
          oldPassword,
          password
        })
        .end((err, response) => {
          if (err) {
            reject(err);
          }
          try {
            const res = JSON.parse(response.text);
            resolve(res);
          } catch (e) {
            resolve('');
          }
        });
    });
  },




}


// WEBPACK FOOTER //
// ./src/utils/Api.js